import { ArrowUpRight, X } from "lucide-react";
import { useState } from "react";

export function AnnouncementBanner() {
  const enabled = import.meta.env.VITE_ANNOUNCEMENT_ENABLED === "true";
  const text = import.meta.env.VITE_ANNOUNCEMENT_TEXT ?? "";
  const id = import.meta.env.VITE_ANNOUNCEMENT_ID || "announcement";
  const link = import.meta.env.VITE_ANNOUNCEMENT_LINK;
  const background = import.meta.env.VITE_ANNOUNCEMENT_BACKGROUND;
  const foreground = import.meta.env.VITE_ANNOUNCEMENT_FOREGROUND;
  const storageKey = `dismissed-announcement:${id}`;
  const [visible, setVisible] = useState(
    () => enabled && Boolean(text) && localStorage.getItem(storageKey) !== "true",
  );

  if (!visible) return null;

  function dismiss() {
    localStorage.setItem(storageKey, "true");
    setVisible(false);
  }

  return (
    <aside
      className="announcement-banner"
      aria-label="Announcement"
      style={{ backgroundColor: background, color: foreground }}
    >
      <span>{text}</span>
      {link ? (
        <a href={link}>
          Learn more
          <ArrowUpRight size={12} />
        </a>
      ) : null}
      <button onClick={dismiss} aria-label="Dismiss announcement">
        <X size={14} />
      </button>
    </aside>
  );
}
